import * as types from './types';
import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';
import { defaultDateFormat } from 'Common/GeneralHelper';

const INITIAL_STATE = {
  fetching: false,
  fetchError: '',
  students: [],
  totalPages: 0,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.REVIEW_INCOMING_APPLICATIONS_STUDENT_LOOKUP_FETCHING:
      return { ...state, fetching: payload };
    case types.REVIEW_INCOMING_APPLICATIONS_STUDENT_LOOKUP_FETCH_ERROR:
      return { ...state, fetchError: payload };
    case types.REVIEW_INCOMING_APPLICATIONS_STUDENT_LOOKUP_SET_STUDENTS:
      return {
        ...state,
        students: payload.Data.Result.map(student => ({
          ...student,
          [Fields.BirthDate]: defaultDateFormat(student[Fields.BirthDate]),
        })),
        totalPages: payload.Data.TotalPages,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/reviewincomingapplications/state/studentlookup/reducer.js